module.exports = __webpack_public_path__ + "img/bell.3797d74b.png";